import React, { Component } from "react";
import FormBase from "./FormBase";

class PageAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit, data } = this.props;
    const user = this.props.form.getFieldsValue();
    if (data && data.uuid) {
      user.uuid = data.uuid;
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handSubmit(user);
      }
    });
  };

  render() {
    return (
      <div style={{ marginBottom: 15 }}>
        <FormBase {...this.props} />
      </div>
    );
  }
}
export default PageAdd;



// WEBPACK FOOTER //
// ./src/components/incubator/back/PageAdd.js